import { Drawer, DrawerProps } from "@mantine/core";

export function EDrawer({ ...props }: DrawerProps) {

  return (
    <Drawer
      padding="xl"
      size={"xl"}
      lockScroll={true}
      position="right"
      {...props}
    >
      {props.children}
    </Drawer>
  );

}